<template>
    <div :class="{'mobile-menu-group':true, 'selected':selected}" ref="root">
        <span class="mobile-menu-group-header" @click="expand">
            {{ name }}
        </span>
        <div class="mobile-menu-items" v-show="open || alwaysOpen">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon", "alwaysOpen"],
    components: {
    },
    data() {
        return {
            open: true,
            selected: false,
        };
    },
    mounted() {
        this.refresh();
        window.addEventListener('mobile-menu-recalc-group', this.refresh);
    },
    unmounted() {
        window.removeEventListener('mobile-menu-recalc-group', this.refresh);
    },
    methods: {
        expand() {
            this.open = !this.open;
        },        
        refresh() {
            const element = this.$refs.root;
            if (element) {
                this.selected = element.querySelector('.mobile-menu-subgroup.selected') !== null;
                if (this.selected) {
                    this.open = true;
                }
            }
        },
    }
}
</script>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>

<style lang="scss" scoped>

.mobile-menu-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 56px;
    //padding-left: 12px;
    //border-bottom: solid 1px #ebebeb;
    /*&.selected {
        a {
            background: darkcyan;
            color: white;
        }
    }*/
}

.mobile-menu-group-header {
    color: #212529;//color: #808080;
    font-weight: 600;
    text-decoration: none;
    font-size: 1.1em;
    padding-left: 16px;
    padding-right: 16px;
    margin-top: 24px;
    //margin-bottom: 8px;
}

.mobile-menu-items {
    display: flex;
    flex-direction: column;
    justify-content: center;
    //margin-left: 16px;
    min-height: 56px;
    //border-bottom: solid 1px #ebebeb;
}

</style>